import type { NgZone } from '@angular/core';
import { EventEmitter } from '@angular/core';

import type { Observable } from 'rxjs';
import { asyncScheduler, BehaviorSubject } from 'rxjs';
import { observeOn } from 'rxjs/operators';

class FakeEventEmitter extends BehaviorSubject<any> {
  public __isAsync: boolean = false;
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public emit(): void {}
  public asObservable(): Observable<any> {
    return super.asObservable().pipe(observeOn(asyncScheduler));
  }
}

// https://github.com/angular/angular/blob/master/packages/core/src/zone/ng_zone.ts#L315-L335
export class NoopNgZone implements NgZone {
  public readonly hasPendingMicrotasks: boolean = false;
  public readonly hasPendingMacrotasks: boolean = false;
  public readonly isStable: boolean = true;
  public readonly onUnstable = new EventEmitter<any>();
  public readonly onMicrotaskEmpty: EventEmitter<any> = <EventEmitter<any>>(
    (<unknown>new FakeEventEmitter(null))
  );
  public readonly onStable: EventEmitter<any> = <EventEmitter<any>>(
    (<unknown>new FakeEventEmitter(null))
  );
  public readonly onError = new EventEmitter<any>();

  public run(fn: () => any): any {
    return fn();
  }

  public runGuarded(fn: () => any): any {
    return fn();
  }

  public runOutsideAngular(fn: () => any): any {
    return fn();
  }

  public runTask<_T>(fn: () => any): any {
    return fn();
  }
}
